/**
 * The table's scene and head in every game view (owner 22.9.2026: "PELKÄSTÄÄN TAUSTA JA LOGO VAIHTUU eli logo ja
 * mahdollinen maa samalla lailla kuin odotustilassa. Muuten pelinäkymä pysyy ennallaan."): the same scene as the
 * table's lobby behind, the table's logo in the lobby's logo box, and — on a public table — the region under it,
 * exactly as the lobby shows them. Nothing else in the view changes.
 */
import { art } from '../art';
import { LobbyLogo } from './LobbyLogo';
import { SCENE, KitText, type KitTx, type LobbyKind } from './LobbyKit';
import { seatOption } from '../state/store';
import type { PublicRoomState } from '@snw/protocol';

export const tableKind = (s: PublicRoomState): LobbyKind => (s.settings.dateMode ? 'date' : s.settings.roomType === 'flirt' ? 'flirt' : s.settings.roomType === 'meet' ? 'meet' : 'friends');
/** the region under the logo (public tables): the table's own words from Public Play, else the room's region code */
const countryName = (code: string): string => { try { return new Intl.DisplayNames(['en'], { type: 'region' }).of(code.toUpperCase()) ?? code; } catch { return code; } };
export const tableRegion = (s: PublicRoomState): string => seatOption.value?.label?.split(' · ')[0] ?? (s.settings.region && s.settings.region !== 'ww' ? countryName(s.settings.region) : 'Worldwide');
/** the region lane as the lobby has it: role region, top 200 (the owner's own value, 22.9.2026) */
export const REGION: KitTx = { id: 'region', text: 'Worldwide', role: 'region', className: 't-region', x: 170, y: 200, w: 600, h: 76, maxW: 600, align: 'center', overflow: 'ellipsis' };

export function TableScene({ s }: { s: PublicRoomState }) {
  return <img class="cut-bg" src={art(SCENE[tableKind(s)])} alt="" draggable={false} />;
}
export function TableHead({ s }: { s: PublicRoomState }) {
  const kind = tableKind(s);
  return (
    <>
      <LobbyLogo kind={kind} />
      {!!s.settings.house && <KitText t={REGION} text={tableRegion(s)} testid="table-region" />}
    </>
  );
}
